// client/src/context/cognitive/cognitiveInitialState.js

export default {
  // Text-to-Speech state
  currentAudio: null,
  isPlaying: false,
  isPaused: false,
  isMuted: false,
  currentVolume: 1.0,
  currentVoice: 'en-US-JennyNeural',
  currentLanguage: 'en-US',
  
  // Speech-to-Text state
  isRecording: false,
  transcribedText: '',
  audioBlob: null,
  recordingDuration: 0,
  
  // General state
  isLoading: false,
  error: null
};